<div class="so-table-token-pagination">
  <div class="so-table-page-size">
    <span class="page-size-label">Mostrar:</span>
    <so-select-ui
      [items]="pageSizeSelectItems()"
      [selectedItemId]="effectivePageSize()"
      [selectLabel]="'Cantidad'"
      [display]="'horizontal'"
      [isFilter]="true"
      (selectionChange)="onPageSizeChange($event)">
    </so-select-ui>
    <span class="page-size-suffix">de {{ totalItems() }}</span>
  </div>
  <div class="so-table-token-nav">
    <button
      class="token-nav-btn"
      [disabled]="isPrevTokenDisabled()"
      [class.disabled]="isPrevTokenDisabled()"
      (click)="onPreviousTokenPage()">
      <span class="material-icons">chevron_left</span>
    </button>
    @if (tokenPaginationState().pageCounter > 1 && !isPrevTokenDisabled()) {
      <button
        class="token-page-btn"
        (click)="onPreviousTokenPage()">
        {{ tokenPaginationState().pageCounter - 1 }}
      </button>
    }
    <button class="token-page-btn active" disabled>
      {{ tokenPaginationState().pageCounter }}
    </button>
    @if (!isNextTokenDisabled() && tokenPaginationState().pageCounter > 0) {
      <button
        class="token-page-btn"
        (click)="onNextTokenPage()">
        {{ tokenPaginationState().pageCounter + 1 }}
      </button>
    }
    <button
      class="token-nav-btn"
      [disabled]="isNextTokenDisabled()"
      [class.disabled]="isNextTokenDisabled()"
      (click)="onNextTokenPage()">
      <span class="material-icons">chevron_right</span>
    </button>
  </div>
</div>
